import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryProvider } from './contexts/QueryProvider';
import { AuthProvider } from './contexts/AuthContext';
import { I18nProvider } from './contexts/I18nContext';
import { FontSizeProvider } from './contexts/FontSizeContext';
import { BreadcrumbProvider } from './contexts/BreadcrumbContext';
import App from './App';
import './App.css';

// SurveyJS styles
import 'survey-core/survey-core.min.css';
import 'survey-creator-core/survey-creator-core.min.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryProvider>
        <I18nProvider>
          <FontSizeProvider>
            <AuthProvider>
              <BreadcrumbProvider>
                <App />
              </BreadcrumbProvider>
            </AuthProvider>
          </FontSizeProvider>
        </I18nProvider>
      </QueryProvider>
    </BrowserRouter>
  </StrictMode>
);
